export default __webpack_public_path__ + "static/custom-software-solutions-3d50a87f468f5efc513c9cf445f691ae.svg";